import type { HelpFile } from '../../types/help'
import { MintApiKeyDialogTestIds } from '../../../testids/MintApiKeyDialogTestIds'

export const mintApiKeyDialogHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [MintApiKeyDialogTestIds.mintDialogTitle]: null,
    [MintApiKeyDialogTestIds.mintForm]: null,
    [MintApiKeyDialogTestIds.mintInputName]:
      'Display name shown in the API Keys table — typically a workload or pipeline identifier (1–100 characters).',
    [MintApiKeyDialogTestIds.mintInputExpiry]:
      'When the key stops working. Defaults to today + 365 days; admins can shorten the lifetime per key.',
    [MintApiKeyDialogTestIds.mintInputRateLimit]:
      'Optional per-key request budget (requests per minute). Leave blank to use the global default.',
    [MintApiKeyDialogTestIds.mintWarningBanner]:
      'The raw key is shown exactly once, on this screen. There is no recovery path — copy it before closing.',
    [MintApiKeyDialogTestIds.mintRawKeyInput]:
      'The minted API key. Save it now in your password manager, vault, or CI secret store; it cannot be retrieved later.',
    [MintApiKeyDialogTestIds.btnCopyRawKey]:
      'Copy the raw key to the clipboard. Disabled on non-HTTPS contexts (e.g. local dev) — copy the field manually instead.',
    [MintApiKeyDialogTestIds.mintCopyDisabledMessage]: null,
    [MintApiKeyDialogTestIds.btnMintSavedClose]:
      'Confirm that the key is saved and close the dialog. The key is dereferenced from React state and cannot be re-displayed.',
    [MintApiKeyDialogTestIds.mintSubmitError]: null,
  },
}
